import styled from "styled-components"

const FlexCol = styled.div`
  flex: 1;
`
export default FlexCol
